import * as React from "react";
import { connect } from "react-redux";
import { IStoreState } from "../../../redux/rootReducer";
import Dropdown from "./Dropdown";
import {
  createGpxFileAll,
  createGpxFileProblem,
} from "../../../redux/computables/gcpRequest/gpxFile";
import {
  AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX,
  AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_ALL,
  AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_PROBLEM,
} from "../../_autotest-constants";
import config from "../../../config";
import { IGcpAppDispatch } from "../../../redux/store";
import { userDownloadsAllGpx, userDownloadsRequestedGpx } from "./scenarios";

interface IGpxDownloadButtonProps {
  gpxFileAll: string;
  gpxFileProblem: string;
  dispatch: IGcpAppDispatch;
}
const GpxDownloadButton = ({
  dispatch,
  gpxFileAll,
  gpxFileProblem,
}: IGpxDownloadButtonProps) => (
  <Dropdown
    label="GPX"
    className={AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX}
    icon={<img src="icon-download.svg" />}
    options={[
      {
        label: config.language === "ru" ? "Все опознаки" : "All Flight Markers",
        className: AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_ALL,
        onClick: () => {
          dispatch(userDownloadsAllGpx(gpxFileAll));
        },
      },
      {
        label:
          config.language === "ru"
            ? "Запрошенные опознаки"
            : "Requested Flight Markers",
        className: AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_PROBLEM,
        onClick: () => {
          dispatch(userDownloadsRequestedGpx(gpxFileProblem));
        },
      },
    ]}
  />
);

export default connect((state: IStoreState) => ({
  gpxFileAll: createGpxFileAll(state),
  gpxFileProblem: createGpxFileProblem(state),
}))(GpxDownloadButton);
